import { PageRef } from 'providers/page-ref';

/**
 * Which fatal error screen to show.
 *
 * The values are also what the screen's Sentry reports are named and tagged with
 * (`fatal_type`, see services/fatal-error-report.ts), so they must never be renamed:
 * a changed value would split every Sentry issue for that cause in two.
 */
export enum FatalErrorKind {
  DatabaseRecoveryError = 'database_recovery_error',
  TestFatalError = 'test_fatal_error',
  BootingError = 'booting_error',
  LockdownModeError = 'lockdown_mode_error',
  ServerError = 'server_error',
  /** #4401: the device's own storage accepted the app's reads and answered none of them. */
  LocalStorageWedged = 'local_storage_wedged',
}

export type FatalErrorPageParams = {
  type: FatalErrorKind;
  error?: any;
  /**
   * #4401: may the page offer "start this device's data over"? Only true when the probe
   * showed the storage layer itself still works and it is one database that is jammed —
   * offering it when the whole storage layer is silent would cost the user their unsynced
   * data and rescue nobody.
   */
  canResetLocalStore?: boolean;
};

export const IFatalErrorPage: PageRef<FatalErrorPageParams, void> = {
  pageName: 'FatalErrorPage',
} as PageRef<FatalErrorPageParams, void>;
